export const EVENT_NAMES = {
  FC_HOME_PAGE_MOBILE_NUMBER_EDIT: 'fc-home-page-mobile-number-edit',
  FC_HOME_PAGE_RENDER: 'fc-home-page-render',
  FC_HOME_PAGE_MOBILE_NUMBER_CLICK: 'fc-home-page-enter-mobile',
  FC_HOME_PAGE_SEND_OTP: 'fc-home-page-send-otp',
  SUBMIT_OTP_CLICK: 'fc-home-page-submit-otp',
  CONSENT_BOX_CLICK: 'Fc-home-page-consent-click',
  GET_STARTED_CLICK: 'Fc-home-page-get-started-click',
  USER_EXITS: 'Fc-user-exits',
  USER_EXITS_RETENTION: 'Fc-user-exits-retention',
  FAILED_TO_CONTINUE: 'Fc-failed-to-continue',
  CHANGE_PAYMENT_METHOD: 'Fc-retry-diff-payment-method',
  PAN_POPUP_RENDER: 'Fc-home-page-pan-pop-up',
  PAN_SUBMIT: 'Fc-home-page-pan-submit',
  PAN_CONFIRM: 'Fc-home-page-pan-confirm',
  PAN_EDIT: 'Fc-home-page-pan-edit',
  DETAILS_PAGE_RENDERED: 'Fc-details-page-pan-name-dob',
  EDIT_PIN_CLICKED: 'Fc-details-page-pincode',
  EMPLOYER_VERIFY_RENDER: 'Fc-employee-verf-page',
  EMPLOYER_NAME_ADDED: 'Fc-employee-name',
  EMPLOYER_VERIFY_CLICKED: 'Fc-employee-verify-check',
  INCOME_VERIFY_FAILED: 'Fc-income-verify-failed',
  EMI_PLANS_LOADER_RENDER: 'Fc-offer-search-page',
  OFFERS_FETCH_RESP: 'Fc-offer-search',
  OFFER_EDIT_PAN: 'Fc-offer-search-edit-pan',
  OFFER_CHANGE_PAYMENT_METHOD: 'Fc-offer-search-change-payment-method',
  EMI_PLANS_RENDER: 'Fc-emi-plans-rendered',
  EMI_PLAN_SELECTED: 'Fc-emi-plans-selected',
  EMI_PLANS_CTA_CLICK: 'Fc-emi-plan-screen-cta-clicked',
  SELFIE_SCREEN_RENDER: 'Fc-kyc-screen',
  CAMERA_ACCESS_CLICK: 'Fc-kyc-camera-access',
  CAPTURE_SELFIE: 'Fc-kyc-take-selfie',
  CONTINUE_TO_DIGILOCKER: 'Fc-kyc-cta-digilocker',
  RETAKE_SELFIE_CLICKED: 'Fc-kyc-retake-selfie',
  SELFIE_KYC_FAILED: 'Fc-kyc-retake-selfie_failed',
  CONTINUE_TO_EMANDATE: 'Fc-cta-emandate-screen',
  EMANDATE_POPUP_RENDER: 'Fc-emandate-screen',
  EMANDATE_POPUP_FAILURE: 'Fc-emandate-failed',
  EMANDATE_CALLBACK_SUCCESS: 'Fc-emandate-success',
  ESIGN_POPUP_RENDER: 'Fc-esign-loaded',
  ESIGN_POPUP_FAILURE: 'Fc-esign-failed',
  SETUP_EMANDATE_CLICK: 'Fc-emandate-setup',
  REPAYMENT_RECEIVED: 'Fc-repayment-url-response',
  VERIFY_EMAIL: 'Fc-verify-email',
  SEND_EMAIL_OTP: 'Fc-add-email-send-OTP',
  VERIFY_EMAIL_OTP: 'Fc-submit-OTP',
  PAYMENT_INITIATION_SCREEN_RENDER: 'Fc-payment-initiation-screen',
  KFS_SHOWN: 'Fc-kfs-shown',
  SUBMIT_OTP_CLICKED: 'Fc-payment-initiation-otp-submit',
  PAYMENT_SUCCESS: 'Fc-payment-success',
  PAYMENT_FAILURE: 'Fc-payment-failure',
  POPUP_RENDER_FAILED: 'Fc-popup-render-failed',
  POPUP_OPEN_FAILED: 'Fc-popup-open-failed',
};

export const ANALYTICS_ACTIONS = {
  RENDER: 'render',
  CLICK: 'click',
  BACKEND_RESPONSE: 'backend-response',
  INPUT: 'input',
  ERROR: 'error',
};

export const OBJECT_NAME = 'Razorpay Flash Credit';
